import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input,
  OnDestroy,
} from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { HouseOrderDetailComponent } from "@root/router/component/house-order-detail/house-order-detail.component";
import _ from "lodash";
import * as moment from "moment";
import { Router } from "@angular/router";

import { OrderMoveHouseComponent } from "@root/component/order-move-house/order-move-house.component";
import { HouseStatusSettingService } from "@root/router/setting/custom-config/house-status-setting.service";
import { StoreService } from "@root/shared/service/store.service";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { tap, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "host-house-orderbox",
  templateUrl: "./house-orderbox.component.html",
  styleUrls: ["./house-orderbox.component.scss"],
})
export class HouseOrderboxComponent implements OnInit, OnDestroy {
  @Input() isHistory = false;
  @ViewChild("ignoreTemplate")
  ignoreTemplate: TemplateRef<any>;
  list = [];
  pageIndex = 1;
  pageTotal = 0;
  channels = [];
  displayNotify = false;
  notshowIgnoreModal = false;
  ignoreModal;
  ignoreReservationId = null;
  taskType: 0 | 1 = 0;
  loading = false;
  refreshAfterOderDetailClosed = false;

  private refreshOrderList$ = this.orderService.orderListRefresh$.pipe(
    tap((value) => {
      this.refreshAfterOderDetailClosed = value;
    })
  );

  private destroy$ = new Subject();

  constructor(
    private modalService: NzModalService,
    private orderService: OrderV2Service,
    private router: Router,
    private houseStatusSettingService: HouseStatusSettingService,
    private storeService: StoreService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.refreshOrderList$.pipe(takeUntil(this.destroy$)).subscribe();
    if (this.isHistory) {
      this.taskType = 1;
    }
    this.judgeeDisplayNotifyOrNot();
    this.getdetail();
    this.getOptions();
  }

  judgeeDisplayNotifyOrNot() {
    const getedNotify = this.storeService.get("orderbox_display_notify", 2);
    this.displayNotify = getedNotify === undefined ? true : getedNotify;
  }

  orderTypeChange(index) {
    if (this.taskType === index) {
      return;
    }
    this.taskType = index;
    this.pageIndex = 1;
    this.getdetail();
  }

  getdetail() {
    this.loading = true;
    const params = {
      page: this.pageIndex,
      page_size: 20,
      type: this.taskType === 0 ? "active" : "history",
      version: "1",
    };
    this.orderService.getReservationBoxList(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.loading = false;
        this.list = this.format(res.data.list);
        this.pageTotal = res.data.list_count;
      }
    });
  }

  getOptions() {
    this.houseStatusSettingService.getSettings().subscribe((res) => {
      if (res.error_code === 0) {
        this.channels = _.get(res, "data.reservation_channel");
      }
    });
  }

  format(data) {
    _.forEach(data, (item) => {
      const check_in = _.get(item, "reservations[0].check_in");
      const check_out = _.get(item, "reservations[0].check_out");
      const total_nights = moment(check_out).diff(moment(check_in), "days");
      // 后端传过来的入住退房时间不是标准格式，所以暂时拼凑一下
      const check_in_time = `${_.split(check_in, " ")[0]} ${_.get(
        item,
        "reservations[0].reservation_checkin_time.check_in_time"
      )}:00`;
      const check_out_time = `${_.split(check_out, " ")[0]} ${_.get(
        item,
        "reservations[0].reservation_checkin_time.check_out_time"
      )}:00`;
      const reservation_tag = _.get(item, "reservations[0].reservation_tag");
      let background;
      switch (_.get(item, "reservations[0].out_status")) {
        case "wait_stay":
          background = "#3ec76e";
          break;
        case "staying":
        case "wait_accept":
          background = "#fb4365";
          break;
        case "completed":
        case "wait_pay":
          background = "#0e5eff";
          break;
        default:
          background = "#5b5b5b";
      }
      _.assign(item, {
        tags: reservation_tag,
        background: background,
        total_nights: total_nights,
        check_in: check_in,
        check_out: check_out,
        check_in_time: check_in_time,
        check_out_time: check_out_time,
      });
    });
    return data;
  }

  showDetails(code) {
    this.orderService.updateOrderListRefresh(false);
    this.modalService.create({
      nzTitle: this.translateService.syncGet("word.order_detail"),
      nzContent: HouseOrderDetailComponent,
      nzFooter: null,
      nzWidth: 900,
      nzComponentParams: {
        code: code,
        pageType:'modal'
      },
      nzOnCancel: () => {
        if (this.refreshAfterOderDetailClosed) {
          this.getdetail();
        }
      },
    });
  }

  getChannel(method) {
    const item = _.find(this.channels, { code: method });
    return item && item.channel_name;
  }

  @WritePermissionGurd("reservation_list")
  deleteTag(tag) {
    const params = {
      reservation_code: tag.reservation_code,
      operator_tag_id: tag.id,
    };
    this.orderService.removeReservationTag(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.getdetail();
      }
    });
  }

  pageChange() {
    this.getdetail();
  }

  @WritePermissionGurd("reservation_list")
  contact(id) {
    this.modalService.closeAll();
    this.router.navigate(["/app/messages"], {
      queryParams: {
        thread_id: id,
      },
    });
  }

  @WritePermissionGurd("reservation_list")
  orderChangeRoom(code) {
    const modalInstance = this.modalService.create({
      nzTitle: this.translateService.syncGet("order.change_to_house"),
      nzContent: OrderMoveHouseComponent,
      nzFooter: null,
      nzWidth: "936px",
      nzComponentParams: {
        codes: code,
      },
    });
    modalInstance.afterClose.subscribe((res) => {
      if (res && res.refresh === true) {
        this.getdetail();
      }
    });
  }

  closeNotify() {
    this.displayNotify = false;
    this.storeService.set("orderbox_display_notify", false, 2);
  }

  ignore(id, isIgnored) {
    // isIgnored为1是忽略，为0是恢复提醒
    if (isIgnored) {
      const showIgnorePrompt =
        this.storeService.get("orderbox_ignore_prompt", 2) === undefined
          ? true
          : this.storeService.get("orderbox_ignore_prompt", 2);
      if (!showIgnorePrompt) {
        this.confirmIgnore(id, isIgnored);
        return;
      }
      this.ignoreReservationId = id;
      this.notshowIgnoreModal = false;
      this.ignoreModal = this.modalService.create({
        nzTitle: null,
        nzFooter: null,
        nzClosable: false,
        nzContent: this.ignoreTemplate,
        nzWidth: 416,
      });
    } else {
      this.confirmIgnore(id, isIgnored);
    }
  }

  showIgnoreModalChange() {
    if (this.notshowIgnoreModal) {
      this.storeService.set("orderbox_ignore_prompt", false, 2);
    } else {
      this.storeService.set("orderbox_ignore_prompt", true, 2);
    }
  }

  closeIgnoreModal() {
    this.ignoreModal.destroy();
  }

  confirmIgnore(id, isIgnored) {
    if (this.ignoreModal) {
      this.ignoreModal.destroy();
    }
    const params = {
      reservation_code: id,
      is_ignored: isIgnored,
    };
    this.orderService.ignoreReservation(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.getdetail();
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
